<div class="risk-slider">
  <p class="ds-ui-2 ds-color-core-neutral-9">{{ 'GROW.riskProfile.profile.summary' | translate }}</p>
  <div class="selected-risk">
    <span class="ds-heading-1 ds-color-core-neutral-10">
      {{ 'GROW.performance.strategy.portfolio.riskProfile.' + getRiskSliderHeading(riskSliderStep) | translate }}
    </span>
  </div>
  <div>
    <div class="suggested-risk">
      <div
        class="suggested-risk-label"
        [style.left]="(100 / totalSteps) * ratioToRiskStep[suggestedRiskSplit] + '%'"
        [ngClass]="{ left: suggestedRiskSplit < 0.2, right: suggestedRiskSplit > 0.8 }"
      >
        <span class="ds-caption-3 ds-color-core-neutral-8">Suggested profile</span>
      </div>
    </div>
    <app-ds-slider [value]="riskSliderStep" [step]="totalSteps" (valueChange)="onRiskProfileChange($event)"></app-ds-slider>
    <div class="slider-labels">
      <div>
        <span class="ds-heading-2 ds-color-core-neutral-10">{{ 1 - selectedRisk | percent: '1.0' }}</span>
        <span class="ds-ui-3 ds-color-core-neutral-7">{{ 'GROW.riskProfile.profile.sustainableFund' | translate }}</span>
      </div>
      <div>
        <span class="ds-heading-2 ds-color-core-neutral-10">{{ selectedRisk | percent: '1.0' }}</span>
        <span class="ds-ui-3 ds-color-core-neutral-7">{{ 'GROW.riskProfile.profile.impactProjects' | translate }}</span>
      </div>
    </div>
  </div>
  <p class="ds-ui-2 ds-color-core-neutral-9">
    <ng-container *ngIf="riskSliderStep !== 0; else showSinglePrediction">
      {{
        'GROW.riskProfile.profile.prediction'
          | translate
            : {
                investment: selectedRisk | percent: '1.0',
                minPercentage: returnForecast.minPercentage | percent: '1.1',
                minAmount: returnForecast.minReturn.toFixed(0) | thousand: currency,
                maxPercentage: returnForecast.maxPercentage | percent: '1.1',
                maxAmount: returnForecast.maxReturn.toFixed(0) | thousand: currency
              }
      }}
    </ng-container>
    <ng-template #showSinglePrediction>
      {{
        'GROW.riskProfile.profile.prediction-single'
          | translate
            : {
                investment: selectedRisk | percent: '1.0',
                minPercentage: returnForecast.minPercentage | percent: '1.1',
                minAmount: returnForecast.minReturn.toFixed(0) | thousand: currency
              }
      }}
    </ng-template>
  </p>
  <p class="ds-ui-2 ds-color-core-neutral-9">{{ 'GROW.riskProfile.profile.disclaimer' | translate }}</p>
</div>

<div class="risk-warning" *ngIf="selectedRisk > suggestedRiskSplit">
  <app-ds-callout variant="warning" [title]="'GROW.riskProfile.profile.warning.' + getRiskSliderHeading(riskSliderStep) | translate"></app-ds-callout>

  <app-ds-checkbox
    [label]="'GROW.riskProfile.profile.dynamicConsent' | translate"
    [errorMessage]="'GROW.riskProfile.profile.errors.acceptConsent' | translate"
    [checked]="acceptConsent"
    [hasError]="showConsentError"
    (clicked)="onToggleConsent()"
  ></app-ds-checkbox>
</div>

<div class="risk-fees">
  <h1 class="ds-heading-1 ds-color-core-neutral-10">{{ 'GROW.performance.strategy.fees.title' | translate }}</h1>
  <p
    class="ds-ui-2"
    [innerHTML]="
      'GROW.riskProfile.profile.growFees'
        | translate
          : {
              notGreenFee: feesConstants.notGreenFee | percent: '1.2-2',
              greenFee: feesConstants.greenFee | percent: '1.2-2',
              prodCostFee: feesConstants.prodCostFee | percent: '1.2-2',
              riskValue: selectedRisk | percent: '1.0',
              totalFee: totalFee | percent: '1.2'
            }
    "
  ></p>
  <app-ds-checkbox
    [label]="'GROW.riskProfile.profile.growFeesConsent' | translate"
    [errorMessage]="'GROW.riskProfile.profile.errors.acceptFees' | translate"
    [checked]="acceptFees"
    [hasError]="showFeesError"
    (clicked)="onToggleFees()"
  ></app-ds-checkbox>
</div>
<div class="risk-actions">
  <app-ds-button type="submit" *ngIf="!hideCTA">
    {{ (editGrowRisk ? 'GROW.riskProfile.UpdateCTA' : 'GROW.riskProfile.CTA') | translate }}
  </app-ds-button>
</div>
